export default __webpack_public_path__ + "static/media/08adfca10da07f007fdd10c49e6ff580a2789b59a89bed196e026741e13e244e.fa82bb0d.png";